import type { WindowWithGoogleTag } from '@gumtree/shared/src/types/window';

const refreshGoogleAds = (window: WindowWithGoogleTag, slotIds: string[]) => {
    if (!window.googletag || !window.googletag.pubads) {
        console.warn('Google Tag Manager is not available.');
        return;
    }

    window.googletag.cmd.push(() => {
        const allSlots = window.googletag.pubads().getSlots();
        const slotsToRefresh = allSlots.filter((slot) => slotIds.includes(slot.getSlotElementId()));

        if (slotsToRefresh.length > 0) {
            window.googletag.pubads().refresh(slotsToRefresh);
        } else {
            console.warn('No matching ad slots found for the given slot IDs.');
        }
    });
};

export default refreshGoogleAds;
